export const CONTACT_CONFIG = {
  phoneNumber: "+44 7848167450",
  
  email: "contact@tvdiamo.com",
  
  whatsappUrl: "https://wa.me/447848167450",
  
  companyName: "TVDIAMO",
  
  websiteUrl: "https://tvdiamo.com"
};

export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
